const logger = window.DD_LOGS?.logger
const bakktRUM = window.DD_RUM

export {logger, bakktRUM}
